function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  x: 500,
  y: 467,
  width: 38,
  height: 42
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  transform: "translate(-500 -467)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M80.7379 101.398C80.7379 94.5669 86.2756 89.0291 93.1068 89.0291 99.938 89.0291 105.476 94.5669 105.476 101.398 105.476 108.229 99.938 113.767 93.1068 113.767 86.2756 113.767 80.7379 108.229 80.7379 101.398Z",
  stroke: "#FFFFFF",
  strokeWidth: 1.86893,
  strokeMiterlimit: 8,
  fill: "none",
  fillRule: "evenodd",
  transform: "matrix(1.00205 0 0 1 427.541 383.68)"
}), /*#__PURE__*/React.createElement("text", {
  fill: "#FFFFFF",
  fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
  fontWeight: 400,
  fontSize: 147,
  transform: "matrix(0.136201 0 0 0.135922 515.707 492)"
}, "P"), /*#__PURE__*/React.createElement("path", {
  d: "M75.4018 89.0291C73.4163 97.9463 71.4307 106.864 76.2844 112.346 81.1382 117.828 92.8311 119.875 104.524 121.922",
  stroke: "#FFFFFF",
  strokeWidth: 1.86893,
  strokeMiterlimit: 8,
  strokeDasharray: "7.47573 5.6068",
  fill: "none",
  fillRule: "evenodd",
  transform: "matrix(1.00205 0 0 1 427.541 383.68)"
}));

function SvgBicycleInfrastructure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 42,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycleInfrastructure);
export default __webpack_public_path__ + "static/media/bicycle-infrastructure.c65fc9be.svg";
export { ForwardRef as ReactComponent };